<template>
  <div id="number-input" class="tw-relative">
    <p>
      <label v-if="showLabel" :for="label" class="tw-text-sm">
        {{ label }}
      </label>
    </p>
    <input
      :type="type"
      ref="numberInput"
      class="tw-w-full tw-text-sm tw-rounded tw-p-4 focus:tw-border-primary"
      :class="{
        'tw-border-error': showError === true,
        'tw-bg-gray-light tw-border-0 tw-cursor-not-allowed': disabled === true,
      }"
      v-model="numberData"
      @input="setInput"
      @keypress="isNumber($event)"
      @keydown.enter="blurInput"
      @blur="validate"
      :placeholder="placeHolder"
      :disabled="disabled"
      :id="id"
      :min="Number(minNumber)"
      :name="name"
      required
    />
    <p class="tw-absolute tw--top-4 tw-right-px tw-text-error tw-text-xs">
      {{ errorMsg }}
    </p>
  </div>
</template>

<script>
  import { convertToLocale, isNumber } from "@/utils/helpers.js";
import useValidate from "@vuelidate/core";
import { maxValue, required } from "@vuelidate/validators";

  export default {
    name: "NumberInput",

    emits: ["set", "valid"],

    props: {
      placeHolder: { type: String, default: () => "", required: true },
      label: { type: String, default: () => "", required: true },
      id: { type: String, default: () => "" },
      name: { type: String, default: () => "" },
      number: { type: String, default: () => "" },
      raiseAmount: { type: String, default: () => "" },
      valuation: { type: String, default: () => "" },
      maxNumber: { type: String, default: () => "" },
      minNumber: { type: String, default: () => "" },
      fieldType: { type: String, default: () => "" },
      type: { type: String, default: () => "" },
      showLabel: { type: Boolean, default: () => false },
      disabled: { type: Boolean, default: () => false },
    },

    data() {
      return {
        v$: useValidate(),
        numberData: "",
        intNumberData: "",
        errorMsg: "",
        showError: false,
      };
    },

    computed: {
      formatNumberData() {
        return this.convertToLocale(Number(this.intNumberData));
      },
    },

    validations() {
      return {
        number: {
          required,
          maxValue:
            this.maxNumber !== "" ? maxValue(Number(this.maxNumber)) : "",
        },
        raiseAmount: { required, maxValue: maxValue(Number(this.maxNumber)) },
        valuation: { required },
      };
    },

    mounted() {
      switch (this.fieldType) {
        case "raiseAmount":
          this.numberData = this.raiseAmount;
          break;
        case "valuation":
          this.numberData = this.valuation;
          break;

        default:
          this.numberData = this.number;
          break;
      }
      // this.numberData === "" ? "" : this.validate();
    },

    methods: {
      isNumber,
      convertToLocale,

      setInput() {
        this.showError = false;
        this.errorMsg = "";
        this.$emit("set", this.intNumberData);
      },

      validate() {
        this.v$.$reset();
        switch (this.fieldType) {
          case "raiseAmount":
            this.v$.raiseAmount.$touch();
            break;
          case "valuation":
            this.v$.valuation.$touch();
            break;

          default:
            this.v$.number.$touch();
            break;
        }
        if (this.v$.$errors.length === 0) {
          this.$emit("valid", true);
          return (this.showError = false), (this.errorMsg = "");
        }
        this.$emit("valid", false);
        this.errorMsg = this.v$.$errors[0].$message;
        this.showError = true;
      },

      blurInput() {
        this.validate();
        setTimeout(() => {
          this.$refs.numberInput?.blur();
        }, 500);
      },
    },

    watch: {
      number(newValue, oldValue) {
        if (newValue !== oldValue) {
          if (this.numberData.split(",").join("") !== newValue) {
            this.numberData = newValue;
          }
          setTimeout(() => {
            this.validate();
          }, 500);
        }
      },

      raiseAmount(newValue, oldValue) {
        if (newValue !== oldValue) {
          if (this.numberData.split(",").join("") !== newValue) {
            this.numberData = newValue;
          }
          setTimeout(() => {
            this.validate();
          }, 500);
        }
      },

      valuation(newValue, oldValue) {
        if (this.fieldType === "raiseAmount") return;

        if (newValue !== oldValue) {
          if (this.numberData.split(",").join("") !== newValue) {
            this.numberData = newValue;
          }
          this.validate();
        }
      },

      formatNumberData(val) {
        if (this.type === "tel") return;
        this.numberData = val;
      },

      numberData(val) {
        this.intNumberData = val.toString().split(",").join("");
      },
    },
  };
</script>

<style lang="scss" scoped></style>
